import React, { useState, useEffect } from 'react';
import { PROJECTS } from '../data/projects';
import './Portfolio.css';

const TABS = [
  { key: 'all',     label: 'All' },
  { key: 'Panto',   label: 'Panto' },
  { key: 'Opera',   label: 'Opera' },
  { key: 'Theater', label: 'Theater' },
  { key: 'Dance',   label: 'Dance' },
];

function tabCount(key) {
  if (key === 'all') return PROJECTS.length;
  return PROJECTS.filter(p => p.type === key || (key === 'Dance' && p.type === 'Dance Film')).length;
}

function matchesTab(p, key) {
  if (key === 'all') return true;
  if (key === 'Dance') return p.type === 'Dance' || p.type === 'Dance Film';
  return p.type === key;
}

function ProjectModal({ project, onClose }) {
  const [activeImg, setActiveImg] = useState(0);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const kinds = ['All', ...Array.from(new Set(project.gallery.map(g => g.kind)))];
  const filtered = filter === 'All' ? project.gallery : project.gallery.filter(g => g.kind === filter);
  const cur = filtered[Math.min(activeImg, filtered.length - 1)] || project.gallery[0];
  const projectNum = PROJECTS.indexOf(project) + 1;

  return (
    <div className="pm-overlay" onClick={onClose}>
      <div className="pm-shell" onClick={e => e.stopPropagation()}>
        <button className="pm-close" onClick={onClose}>Close ✕</button>

        <div className="pm-header">
          <div>
            <div className="pm-eyebrow">{project.type} · {project.year}</div>
            <h2 className="pm-title">{project.title}</h2>
            <div className="pm-venue">{project.venue}</div>
          </div>
          <div className="pm-counter">
            <span>{String(projectNum).padStart(2, '0')}</span>
            <span style={{ opacity: 0.4 }}> / {String(PROJECTS.length).padStart(2, '0')}</span>
          </div>
        </div>

        <div className="pm-body">
          <div className="pm-stage">
            {cur.kind === 'Video'
              ? <a href={cur.ytUrl} target="_blank" rel="noopener noreferrer" className="yt-link pm-video">
                  <img src={cur.thumb} alt={cur.caption} />
                  <div className="yt-play">
                    <div className="yt-play-btn" />
                    <span className="yt-play-label">Watch on YouTube</span>
                  </div>
                </a>
              : <img src={cur.src} alt={cur.caption} className="pm-img" />
            }
            <div className="pm-caption">
              <span className="pm-cap-kind">{cur.kind}</span>
              <span className="pm-cap-text">{cur.caption}</span>
            </div>
          </div>

          <div className="pm-side">
            <div className="pm-filters">
              {kinds.map(k => (
                <button
                  key={k}
                  className={`pm-filter${filter === k ? ' active' : ''}`}
                  onClick={() => { setFilter(k); setActiveImg(0); }}
                >
                  {k}
                  <span style={{ opacity: 0.5 }}>
                    {k === 'All' ? project.gallery.length : project.gallery.filter(g => g.kind === k).length}
                  </span>
                </button>
              ))}
            </div>
            <div className="pm-thumbs">
              {filtered.map((g, i) => (
                <button
                  key={i}
                  className={`pm-thumb${i === activeImg ? ' active' : ''}`}
                  onClick={() => setActiveImg(i)}
                >
                  <img src={g.thumb ?? g.src} alt={g.caption} />
                  <span className="pm-thumb-kind">{g.kind}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Portfolio = () => {
  const [active, setActive] = useState('all');
  const [openProject, setOpenProject] = useState(null);

  const items = PROJECTS.filter(p => matchesTab(p, active));

  return (
    <div className="portfolio">
      <div className="section-inner">
        <div className="section-label">Portfolio</div>
        <h2 className="section-title">Selected <em>Productions</em></h2>

        <div className="portfolio-tabs">
          {TABS.map(t => (
            <button
              key={t.key}
              className={`tab-btn${active === t.key ? ' active' : ''}`}
              onClick={() => setActive(t.key)}
            >
              {t.label} <span className="tab-count">{tabCount(t.key)}</span>
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {items.map(item => (
            <div
              key={item.id}
              className="portfolio-item"
              onClick={() => setOpenProject(item)}
            >
              <img src={item.mainImg} alt={item.title} loading="lazy" />
              <div className="portfolio-item-overlay">
                <div className="portfolio-item-num">{String(PROJECTS.indexOf(item) + 1).padStart(2, '0')}</div>
                <div className="portfolio-item-title">{item.title}</div>
                <div className="portfolio-item-sub">{item.type} · {item.venue} · {item.year}</div>
                <div className="portfolio-item-cta">View Project →</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {openProject && <ProjectModal project={openProject} onClose={() => setOpenProject(null)} />}
    </div>
  );
};

export default Portfolio;